import PropTypes from 'prop-types';
import React from 'react';
import { type Control, useWatch } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as InfoIcon } from '@assets/svg/ic-info.svg';

import EditorForm from '@components/form/EditorForm/EditorForm';
import RadioButtonsGroup from '@components/form/RadioButtonsGroup/RadioButtonsGroup';
import Checkbox from '@components/uikit/Checkbox/Checkbox';

import useTranslation from '@hooks/useTranslation';

import { COMPLETION_REPORT_FIELDS } from '../constants/schemaCompletionReport';
import { getRepairsOrMaintenanceList } from '../helpers/getRepairsOrMaintenanceList';
import AttachmentsField from './AttachmentsField/AttachmentsField';
import style from './style.module.scss';

interface IProps {
  control: Control;
  isWwAi: boolean;
}

const StepBasicInfo: React.FC<IProps> = ({ control, isWwAi }) => {
  const { t } = useTranslation();

  const anyRepairsOrMaintenanceList = getRepairsOrMaintenanceList(t, isWwAi);

  const [anyRepairsOrMaintenance] = useWatch({
    control,
    name: [COMPLETION_REPORT_FIELDS.ANY_REPAIRS_OR_MAINTENANCE],
  });

  return (
    <div className={style.stepBasic}>
      <div className={style.relative}>
        <EditorForm
          name={COMPLETION_REPORT_FIELDS.TEXT}
          control={control}
          label="Maintenance performed"
          dataQa={COMPLETION_REPORT_FIELDS.TEXT}
          required
        />
        <InfoIcon id="info-icon" className={style.infoIcon} />
      </div>
      {!isWwAi && (
        <Checkbox
          name={COMPLETION_REPORT_FIELDS.IS_SENSOR_ATTACHED}
          control={control}
          label={'I confirm that the sensor is securely attached to the equipment.'}
          required
        />
      )}
      <RadioButtonsGroup
        name={COMPLETION_REPORT_FIELDS.ANY_REPAIRS_OR_MAINTENANCE}
        control={control}
        label={
          !isWwAi
            ? 'Did you perform any cleaning, lubrication or other repair/maintenance in order to close this action item?'
            : 'Did you conduct any repair or maintenance in order to close this Action Item?'
        }
        type="column"
        options={anyRepairsOrMaintenanceList}
        required
      />
      {isWwAi && anyRepairsOrMaintenance === 'maintenance' && (
        <AttachmentsField name={COMPLETION_REPORT_FIELDS.FILE_NAME} control={control} label="Attachments" />
      )}
      <Tooltip
        anchorSelect="#info-icon"
        content={t('Describe any maintenance that was completed or actions that were taken.')}
      />
    </div>
  );
};

export default StepBasicInfo;
